/**
 * Connector entity — mirrors `leviathan_master.connectors`.
 *
 * Credentials are never stored in `config`; they live in AWS Secrets Manager
 * under `leviathan/{tenantId}/connector/{connectorId}` and `config` references
 * them via `credentialsSecretArn`.
 */
import { z } from 'zod';
import { ConnectorId, ISO8601Date, TenantId, UserId, } from '../primitives/index.js';
import { ConnectorStatus, ConnectorType } from '../enums/index.js';
/** Connector-type-agnostic config envelope; callers validate specifics at the edge. */
export const ConnectorConfigSchema = z.record(z.string(), z.unknown());
export const ConnectorSchema = z.object({
    id: ConnectorId,
    tenantId: TenantId,
    name: z.string().min(1).max(100),
    type: ConnectorType,
    config: ConnectorConfigSchema,
    credentialsSecretArn: z.string().max(255).nullable(),
    status: ConnectorStatus,
    lastSyncAt: ISO8601Date.nullable(),
    lastError: z.string().nullable(),
    createdBy: UserId.nullable(),
    createdAt: ISO8601Date,
    updatedAt: ISO8601Date,
});
/** Public view — omits ARN; safe to render on management UI lists. */
export const ConnectorPublicSchema = ConnectorSchema.omit({ credentialsSecretArn: true });
export const ConnectorCreateSchema = z.object({
    name: z.string().min(1).max(100),
    type: ConnectorType,
    config: ConnectorConfigSchema,
    /**
     * Sensitive credentials sent at creation time; the backend extracts them,
     * stores them in Secrets Manager, and NEVER persists them in DB.
     */
    credentials: z.record(z.string(), z.string()).optional(),
});
export const ConnectorUpdateSchema = z
    .object({
    name: z.string().min(1).max(100),
    config: ConnectorConfigSchema,
    status: ConnectorStatus,
    credentials: z.record(z.string(), z.string()),
})
    .partial();
//# sourceMappingURL=connector.js.map